import { Container, makeStyles } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { fetchCandidate } from '../../../api/candidate';
import Education from '../../../components/education';
import Experiences from '../../../components/experiences';
import Introduce from '../../../components/introduce';
import Loader from '../../../components/loader';
import Overview from '../../../components/overview';
import Quotes from '../../../components/quotes';
import Skills from '../../../components/skills';
import { COLORS } from '../../../constants/colors';
import useFetch from '../../../hooks/useFetch';
import NotFoundPage from '../../404';
import PublicPage from '../../base/public';
import { trackCandidateView } from '../../../helpers/firebase';

const useStyles = makeStyles({
  root: {
    '& > section:nth-child(even)': {
      backgroundColor: COLORS.grayScale[1],
    },
  },
  container: {
    maxWidth: '90rem',
    padding: '2rem 3.125rem',
  },
  loader: {
    paddingTop: '3rem',
  },
});

const ViewPage = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const { hash } = useParams();
  const { isLoading, result: candidate } = useFetch(fetchCandidate, hash, [
    hash,
  ]);
  const onEdit = () => {
    history.push(props.location.pathname + '/edit');
  }

  useEffect(() => {
    if(candidate){
      trackCandidateView(
        `${candidate.firstName} ${candidate.lastName}`,
        candidate.hash,
      )
    }
  }, [candidate])

  if (!isLoading && !candidate)
    return (
      <NotFoundPage message="The profile you are looking for is not available at the moment" />
    );


  

  return (
    <PublicPage withActions={true} onEdit={onEdit}>
      {isLoading && (
        <Loader className={classes.loader} label="Searching candidate ..." />
      )}
      {candidate && (
        <div className={classes.root}>
          <section>
            <Container className={classes.container}>
              <Introduce {...candidate} />
              <Skills title="Skills"/>
              <Overview {...candidate} />
            </Container>
          </section>
          <section>
            <Container className={classes.container}>
              <Experiences/>
            </Container>
          </section>
          <section>
            <Container className={classes.container}>
              <Education />
              <Quotes />
            </Container>
          </section>
        </div>
      )}
    </PublicPage>
  );
};

export default ViewPage;
